module.exports = __webpack_public_path__ + "img/35.6f4f4586.png";